import React, { useState, useEffect, useContext, useRef } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import UserContext from "../context/UserContext";
import { login, getOtp } from "../Services/Service";
import OTPInput, { ResendOTP } from "otp-input-react";
import pentaimg from "../css/img/profilePicture1.jpg";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { BottomSheetCustom } from "@cred/neopop-web/lib/components";
import { login_begin, login_complete } from "../Services/events";
import "./bottomLogin.css";

const initialValue = {
  userPhonenumber: "",
  password: "",
  username: "",
};

// Country to ISO 3166-1 alpha-2 code mapping (for flag images)
const countryCodes = {
  Afghanistan: "af",
  Albania: "al",
  Algeria: "dz",
  Andorra: "ad",
  Angola: "ao",
  "Antigua and Barbuda": "ag",
  Argentina: "ar",
  Armenia: "am",
  Australia: "au",
  Austria: "at",
  Azerbaijan: "az",
  Bahamas: "bs",
  Bahrain: "bh",
  Bangladesh: "bd",
  Barbados: "bb",
  Belarus: "by",
  Belgium: "be",
  Belize: "bz",
  Benin: "bj",
  Bhutan: "bt",
  Bolivia: "bo",
  "Bosnia and Herzegovina": "ba",
  Botswana: "bw",
  Brazil: "br",
  Brunei: "bn",
  Bulgaria: "bg",
  "Burkina Faso": "bf",
  Burundi: "bi",
  "Cabo Verde": "cv",
  Cambodia: "kh",
  Cameroon: "cm",
  Canada: "ca",
  "Central African Republic": "cf",
  Chad: "td",
  Chile: "cl",
  China: "cn",
  Colombia: "co",
  Comoros: "km",
  Congo: "cg",
  "Costa Rica": "cr",
  Croatia: "hr",
  Cuba: "cu",
  Cyprus: "cy",
  "Czech Republic": "cz",
  Denmark: "dk",
  Djibouti: "dj",
  Dominica: "dm",
  "Dominican Republic": "do",
  Ecuador: "ec",
  Egypt: "eg",
  "El Salvador": "sv",
  "Equatorial Guinea": "gq",
  Eritrea: "er",
  Estonia: "ee",
  Eswatini: "sz",
  Ethiopia: "et",
  Fiji: "fj",
  Finland: "fi",
  France: "fr",
  Gabon: "ga",
  Gambia: "gm",
  Georgia: "ge",
  Germany: "de",
  Ghana: "gh",
  Greece: "gr",
  Grenada: "gd",
  Guatemala: "gt",
  Guinea: "gn",
  "Guinea-Bissau": "gw",
  Guyana: "gy",
  Haiti: "ht",
  Honduras: "hn",
  Hungary: "hu",
  Iceland: "is",
  India: "in",
  Indonesia: "id",
  Iran: "ir",
  Iraq: "iq",
  Ireland: "ie",
  Israel: "il",
  Italy: "it",
  Jamaica: "jm",
  Japan: "jp",
  Jordan: "jo",
  Kazakhstan: "kz",
  Kenya: "ke",
  Kiribati: "ki",
  Kuwait: "kw",
  Kyrgyzstan: "kg",
  Laos: "la",
  Latvia: "lv",
  Lebanon: "lb",
  Lesotho: "ls",
  Liberia: "lr",
  Libya: "ly",
  Liechtenstein: "li",
  Lithuania: "lt",
  Luxembourg: "lu",
  Madagascar: "mg",
  Malawi: "mw",
  Malaysia: "my",
  Maldives: "mv",
  Mali: "ml",
  Malta: "mt",
  "Marshall Islands": "mh",
  Mauritania: "mr",
  Mauritius: "mu",
  Mexico: "mx",
  Micronesia: "fm",
  Moldova: "md",
  Monaco: "mc",
  Mongolia: "mn",
  Montenegro: "me",
  Morocco: "ma",
  Mozambique: "mz",
  Myanmar: "mm",
  Namibia: "na",
  Nauru: "nr",
  Nepal: "np",
  Netherlands: "nl",
  "New Zealand": "nz",
  Nicaragua: "ni",
  Niger: "ne",
  Nigeria: "ng",
  "North Korea": "kp",
  "North Macedonia": "mk",
  Norway: "no",
  Oman: "om",
  Pakistan: "pk",
  Palau: "pw",
  Palestine: "ps",
  Panama: "pa",
  "Papua New Guinea": "pg",
  Paraguay: "py",
  Peru: "pe",
  Philippines: "ph",
  Poland: "pl",
  Portugal: "pt",
  Qatar: "qa",
  Romania: "ro",
  Russia: "ru",
  Rwanda: "rw",
  "Saint Kitts and Nevis": "kn",
  "Saint Lucia": "lc",
  "Saint Vincent and the Grenadines": "vc",
  Samoa: "ws",
  "San Marino": "sm",
  "Sao Tome and Principe": "st",
  "Saudi Arabia": "sa",
  Senegal: "sn",
  Serbia: "rs",
  Seychelles: "sc",
  "Sierra Leone": "sl",
  Singapore: "sg",
  Slovakia: "sk",
  Slovenia: "si",
  "Solomon Islands": "sb",
  Somalia: "so",
  "South Africa": "za",
  "South Korea": "kr",
  "South Sudan": "ss",
  Spain: "es",
  "Sri Lanka": "lk",
  Sudan: "sd",
  Suriname: "sr",
  Sweden: "se",
  Switzerland: "ch",
  Syria: "sy",
  Taiwan: "tw",
  Tajikistan: "tj",
  Tanzania: "tz",
  Thailand: "th",
  "Timor-Leste": "tl",
  Togo: "tg",
  Tonga: "to",
  "Trinidad and Tobago": "tt",
  Tunisia: "tn",
  Turkey: "tr",
  Turkmenistan: "tm",
  Tuvalu: "tv",
  Uganda: "ug",
  Ukraine: "ua",
  "United Arab Emirates": "ae",
  "United Kingdom": "gb",
  "United States": "us",
  Uruguay: "uy",
  Uzbekistan: "uz",
  Vanuatu: "vu",
  "Vatican City": "va",
  Venezuela: "ve",
  Vietnam: "vn",
  Yemen: "ye",
  Zambia: "zm",
  Zimbabwe: "zw",
};

// Function to get flag image URL
const getFlagUrl = (countryName) => {
  const code = countryCodes[countryName]?.toLowerCase() || "";
  return code ? `https://flagcdn.com/w40/${code}.png` : "";
};

// Comprehensive list of countries
const countries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

const BottomLogin = ({ reredirect, onClose }) => {
  const { state, updateInfo } = useContext(UserContext);
  const [OTP, setOTP] = useState("");
  const [mobile, setMobile] = useState("");
  const [registerdMobile, setRegisteredMobile] = useState("");
  const [registerdEmail, setRegisteredEmail] = useState("");
  const [showTimer, setShowTimer] = useState("");
  const [email, setEmail] = useState("");
  const [emailOTP, setEmailOTP] = useState("");
  const [isIndianCitizen, setIsIndianCitizen] = useState(true); // Default to Indian citizen
  const [countryName, setCountryName] = useState("");
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [countrySearchQuery, setCountrySearchQuery] = useState("");

  const buttonRef = useRef(null);
  const countryDropdownRef = useRef(null);
  const otpTimerRef = useRef(null);
  const otpTimeoutRef = useRef(null);

  const [showVerificationForm, setShowVerificationForm] = useState(false);
  const [initialLoginMethod, setInitialLoginMethod] = useState(null);

  // Hide back button when loginMethod pre-selects the flow
  const hideEntryBackButton = ["mobile", "email"].includes(initialLoginMethod);
  const [alreadyRegisteredFlag, setAlreadyRegisteredFlag] = useState(
    localStorage.getItem("alreadyRegistered") || "N"
  );

  // Check loginMethod from credentials API and set initial flow
  useEffect(() => {
    const loginMethod = localStorage.getItem("loginMethod");
    const userCountry = localStorage.getItem("userCountry");

    if (loginMethod) {
      setInitialLoginMethod(loginMethod);
      if (loginMethod === "email" && userCountry && userCountry !== "India") {
        // Email login for non-India: set country, skip selection, go to email step
        setIsIndianCitizen(false);
        setCountryName(userCountry);
        setShowVerificationForm(true); // Skip citizenship selection, go directly to email form
      } else if (loginMethod === "mobile" && userCountry === "India") {
        // Mobile login for India: set India, skip selection, go to mobile step
        setIsIndianCitizen(true);
        setCountryName("India");
        setShowVerificationForm(true); // Skip citizenship selection, go directly to mobile form
      } else {
        // Invalid combination or empty country - show country selection (keep showVerificationForm as false)
      }
    }
    // If loginMethod is empty, keep default behavior (showVerificationForm = false shows country selection)
  }, []);

  // Check WebOTP API support on component mount
  useEffect(() => {
    const checkWebOTPSupport = () => {
      // Check if WebOTP API is available
      const hasOTPCredential = "OTPCredential" in window;
      const hasNavigatorCredentials =
        navigator.credentials &&
        typeof navigator.credentials.get === "function";

      // Check if we're on a supported platform (Chrome/Edge on Android)
      const isAndroid = /Android/i.test(navigator.userAgent);
      const isChrome =
        /Chrome/i.test(navigator.userAgent) &&
        !/Edge/i.test(navigator.userAgent);
      const isEdge = /Edg/i.test(navigator.userAgent);
      const isSupportedBrowser = isChrome || isEdge;

      // Check if we're on HTTPS or localhost
      const isSecureContext =
        window.isSecureContext ||
        window.location.protocol === "https:" ||
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1";

      // WebOTP API works best on Android Chrome/Edge with HTTPS
      const isFullySupported =
        hasOTPCredential &&
        hasNavigatorCredentials &&
        isAndroid &&
        isSupportedBrowser &&
        isSecureContext;

      setOtpAutoReadSupported(isFullySupported);

      if (hasOTPCredential && !isFullySupported) {
        console.log("WebOTP API detected but may not work properly:", {
          hasOTPCredential,
          hasNavigatorCredentials,
          isAndroid,
          isSupportedBrowser,
          isSecureContext,
          userAgent: navigator.userAgent,
        });
      }
    };

    checkWebOTPSupport();
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        countryDropdownRef.current &&
        !countryDropdownRef.current.contains(event.target)
      ) {
        setShowCountryDropdown(false);
      }
    };

    if (showCountryDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCountryDropdown]);

  // Cleanup timers on unmount
  useEffect(() => {
    return () => {
      if (otpTimerRef.current) {
        clearInterval(otpTimerRef.current);
      }
      if (otpTimeoutRef.current) {
        clearTimeout(otpTimeoutRef.current);
      }
    };
  }, []);

  // console.log(mobile)
  const myForm = useRef();
  const nav = useNavigate();
  const location = useLocation();
  // console.log(location.state);
  const [otp, setOtp] = useState("");

  const [user, setUser] = useState(initialValue);
  //  console.log(user)
  const [formErrors, setFormErrors] = useState("");
  const [otpStatus, setOtpStatus] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [time, setTime] = useState(false);
  const [isOtp, setIsOtp] = useState(false);
  const [isAutoReading, setIsAutoReading] = useState(false);
  const [otpAutoReadSupported, setOtpAutoReadSupported] = useState(false);
  // console.log(otpStatus)

  const [alertInfo, setAlertInfo] = useState({
    visible: false,
    cls: "",
    msg: "",
  });
  const [alertInfos, setAlertInfos] = useState({
    visible: false,
    cls: "",
    msg: "",
  });
  const [otpSentMessage, setOtpSentMessage] = useState(""); // Store original OTP sent message
  const [otpErrorMessage, setOtpErrorMessage] = useState(""); // Store error message separately
  const onShowAlert = (msg, visible, clas) => {
    setAlertInfo({
      ...alertInfo,
      ["visible"]: visible,
      ["cls"]: clas,
      ["msg"]: msg,
    });
  };

  const onValueChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleClick = (e) => {
    // console.log(e.target.name)
    myForm.current = e.target.name;
  };
  function validateForm(e) {
    if (isIndianCitizen) {
      if (e === true || e?.target.name === "Send_OTP") {
        if (mobile.length !== 10) {
          setFormErrors("Please Enter 10 digit Mobile No.");
          return false;
        } else {
          setFormErrors("");
          return true;
        }
      } else {
        if (OTP.length !== 6) {
          setFormErrors("");
          setFormErrors("Please Enter 6 digit OTP");
          return false;
        } else {
          setFormErrors("");
          return true;
        }
      }
    } else {
      // Non-Indian citizen, email verification
      if (e === true || e?.target.name === "Send_Email_OTP") {
        if (email.trim() === "") {
          setFormErrors("Please Enter your Email Address.");
          return false;
        } else {
          setFormErrors("");
          return true;
        }
      } else {
        if (emailOTP.length !== 6) {
          setFormErrors("");
          setFormErrors("Please Enter 6 digit OTP");
          return false;
        } else {
          setFormErrors("");
          return true;
        }
      }
    }
  }

  const [rewardModal, setRewardModal] = useState({
    visible: false,
    message: "",
    redirect: null,
  });

  const verifyOtp = async () => {
    try {
      let loginPromise;
      if (isIndianCitizen) {
        loginPromise = login(registerdMobile, OTP, 1, false);
      } else {
        loginPromise = login(registerdEmail, emailOTP, 1, true, countryName);
      }

      const response = await loginPromise;
      await login_complete();

      const {
        status,
        msg: message,
        auth,
        redirect,
      } = response?.data?.data || {};
      const registrationResult = response?.data?.result;

      if (status === 1) {
        // Save auth token and update UI state
        localStorage.setItem("auth", auth);
        setOtpStatus(1);
        updateInfo();
        onClose();
        setIsOtp(false);

        // Show success alert
        onShowAlert(message, true, "success");

        if (registrationResult?.success) {
          setRewardModal({
            visible: true,
            message:
              registrationResult.message ||
              "Congratulations! Your registration reward has been claimed.",
            redirect: redirect,
          });
          return;
        }

        handlePostLoginRedirect(redirect);
      } else {
        // Show failure alert with message from API
        showErrorAlert(message);
      }
    } catch (error) {
      console.error("Login failed", error);
      showErrorAlert("Login failed. Please try again.");
    }
  };

  const handlePostLoginRedirect = (redirectPath) => {
    if (redirectPath === "/register") {
      nav("/register", {
        state: {
          redirect: redirectPath,
          reredirect: location.pathname,
        },
      });
    } else {
      nav("/congratulations", {
        state: { redirect: location.pathname },
      });
    }
  };

  const handleRewardModalClose = () => {
    const { redirect } = rewardModal;
    setRewardModal({
      visible: false,
      message: "",
      redirect: null,
    });
    handlePostLoginRedirect(redirect);
  };

  // Helper function to show error alert
  const showErrorAlert = (message) => {
    // Clear any running OTP timer to prevent it from overwriting the error message
    if (otpTimerRef.current) {
      clearInterval(otpTimerRef.current);
      otpTimerRef.current = null;
    }
    if (otpTimeoutRef.current) {
      clearTimeout(otpTimeoutRef.current);
      otpTimeoutRef.current = null;
    }

    // Store the error message separately
    setOtpErrorMessage(message);

    setAlertInfo({
      ...alertInfo,
      visible: true,
      cls: "danger",
      msg: message, // Keep original message for backward compatibility
    });
    setIsOtp(false);
  };

  const submitHandle = async (e) => {
    if (e.preventDefault) {
      e.preventDefault();
    }

    const isSendOtpFlow =
      e === true ||
      e?.target.name === "Send_OTP" ||
      e?.target.name === "Send_Email_OTP";

    if (isSendOtpFlow) {
      let isvalidForm = validateForm(e);
      login_begin();

      if (isvalidForm) {
        setTime(true);
        let otpPromise;
        let contactType;
        let contactValue;

        if (isIndianCitizen) {
          otpPromise = getOtp(mobile);
          contactType = "mobile";
          contactValue = mobile;
        } else {
          otpPromise = getOtp(email); // Assuming getOtp can handle email
          contactType = "email";
          contactValue = email;
        }

        await otpPromise
          .then((response) => {
            const status = response.data.data?.status;
            const message = response.data.data?.msg;

            if (status === 1) {
              if (isIndianCitizen) {
                setRegisteredMobile(response.data.data?.registerdMobile);
              } else {
                setRegisteredEmail(response.data.data?.registerdEmail);
              }
              setDisabled(true);

              // Store the original OTP sent message and clear any previous error
              setOtpSentMessage(message);
              setOtpErrorMessage("");

              // Clear any existing timers first
              if (otpTimerRef.current) {
                clearInterval(otpTimerRef.current);
              }
              if (otpTimeoutRef.current) {
                clearTimeout(otpTimeoutRef.current);
              }

              let i = 30;
              const timerId = setInterval(() => {
                // Only update if alert is still success (not error)
                setAlertInfo((prev) => {
                  if (prev.cls === "danger") {
                    // Don't overwrite error messages
                    return prev;
                  }
                  return {
                    ...prev,
                    visible: true,
                    cls: "success",
                    msg: `${message}`,
                  };
                });
                setShowTimer(`Resend in ${i--}s`);
              }, 1000);

              otpTimerRef.current = timerId;

              const timeoutId = setTimeout(() => {
                clearInterval(timerId);
                otpTimerRef.current = null;
                setAlertInfo((prev) => {
                  if (prev.cls === "danger") {
                    // Don't overwrite error messages
                    return prev;
                  }
                  return {
                    ...prev,
                    visible: true,
                    cls: "success",
                    msg: message,
                  };
                });
                setShowTimer(``);
                setTime(false);
              }, 30000);

              otpTimeoutRef.current = timeoutId;

              // Begin SMS auto-read only for mobile
              if (isIndianCitizen) {
                const signal = new AbortController();
                const timeoutId = setTimeout(() => {
                  signal.abort();
                }, 1 * 60 * 1000); // 1 minute timeout

                async function main() {
                  // Only attempt auto-read if WebOTP is properly supported
                  if (
                    otpAutoReadSupported &&
                    "OTPCredential" in window &&
                    navigator.credentials
                  ) {
                    setIsAutoReading(true);
                    try {
                      const content = await navigator.credentials.get({
                        signal: signal.signal,
                        otp: {
                          transport: ["sms"],
                          // Optional: specify the origin to match SMS format
                          // The SMS should contain: @yourdomain.com #123456
                        },
                      });

                      if (content && content.code) {
                        setOTP(content.code);
                        clearTimeout(timeoutId);
                        setAlertInfo({
                          ...alertInfo,
                          visible: true,
                          cls: "success",
                          msg: "OTP auto-filled successfully!",
                        });
                      }
                    } catch (err) {
                      // Handle different error types
                      if (err.name === "AbortError") {
                        console.log(
                          "OTP auto-read was aborted (timeout or user cancelled)"
                        );
                      } else if (err.name === "NotAllowedError") {
                        console.log(
                          "OTP auto-read not allowed (permissions or user denied)"
                        );
                      } else if (err.name === "InvalidStateError") {
                        console.log(
                          "OTP auto-read invalid state (already in progress)"
                        );
                      } else {
                        console.log(
                          "OTP auto-read failed:",
                          err.name,
                          err.message
                        );
                      }
                      // Don't show error to user - they can still enter OTP manually
                    } finally {
                      setIsAutoReading(false);
                      clearTimeout(timeoutId);
                    }
                  } else {
                    // WebOTP not supported - user will enter manually
                    console.log(
                      "WebOTP API not supported on this device/browser"
                    );
                  }
                }

                // Start auto-read after a short delay to ensure SMS is sent
                setTimeout(() => {
                  main();
                }, 500);
              }
            } else {
              setAlertInfo({
                ...alertInfo,
                visible: true,
                cls: "danger",
                msg: message,
              });
            }
          })
          .catch((error) => {
            console.error("OTP request failed", error);
            setAlertInfo({
              ...alertInfo,
              visible: true,
              cls: "danger",
              msg: "Failed to get OTP. Please try again later.",
            });
          });
      }
    } else {
      // OTP verification flow
      let isvalidForm = validateForm(e);
      if (isvalidForm) {
        let loginPromise;
        if (isIndianCitizen) {
          loginPromise = login(registerdMobile, OTP, 1, false);
        } else {
          loginPromise = login(registerdEmail, emailOTP, 1, true, countryName);
        }

        try {
          const response = await loginPromise;
          await login_complete();

          const {
            status,
            msg: message,
            auth,
            redirect,
          } = response?.data?.data || {};

          if (status === 1) {
            localStorage.setItem("auth", auth);
            setOtpStatus(1);
            updateInfo();
            onClose();
            setIsOtp(false);

            onShowAlert(message, true, "success");

            if (redirect === "/register") {
              nav("/register", {
                state: {
                  redirect: redirect,
                  reredirect: location.pathname,
                },
              });
            } else {
              nav("/congratulations", {
                state: { redirect: location.pathname },
              });
            }
          } else {
            showErrorAlert(message);
          }
        } catch (error) {
          console.error("Login failed", error);
          showErrorAlert("Login failed. Please try again.");
        }
      }
    }
  };

  const renderButton = (buttonProps) => {
    // console.log(buttonProps)
    return (
      <span>
        {buttonProps.remainingTime !== 0
          ? `Please wait for ${buttonProps.remainingTime} sec`
          : ""}
      </span>
    );
  };
  const renderTime = (remainingTime) => {
    return React.Fragment;
  };
  console.log(showTimer, "showTimer");

  const handleProceed = () => {
    setShowVerificationForm(true);
  };

  const handleGoBack = () => {
    // Clear any running timers
    if (otpTimerRef.current) {
      clearInterval(otpTimerRef.current);
      otpTimerRef.current = null;
    }
    if (otpTimeoutRef.current) {
      clearTimeout(otpTimeoutRef.current);
      otpTimeoutRef.current = null;
    }

    setShowVerificationForm(false);
    // Reset form state when going back
    setMobile("");
    setEmail("");
    setOTP("");
    setEmailOTP("");
    setRegisteredMobile("");
    setRegisteredEmail("");
    setCountryName("");
    setDisabled(false);
    setTime(false);
    setShowTimer("");
    setFormErrors("");
    setOtpSentMessage("");
    setOtpErrorMessage("");
    setAlertInfo({
      visible: false,
      cls: "",
      msg: "",
    });
    setAlertInfos({
      visible: false,
      cls: "",
      msg: "",
    });
  };

  return (
    <>
      <div className="container">
        {!showVerificationForm ? (
          <div className="login-penta bg-common mb-5">
            <div className="row align-items-center">
              <div className="">
                <div className="login-content text-center">
                  <h1 className="my-2 fs-2">Welcome to IceSpice</h1>

                  {/* Citizenship Selection Box */}
                  <div className="citizenship-container">
                    <p className="citizenship-question-text mb-3">
                      Are you an Indian citizen?
                    </p>
                    <div className="citizenship-options">
                      <div
                        className={`citizenship-box ${
                          isIndianCitizen ? "selected" : ""
                        }`}
                        onClick={() => setIsIndianCitizen(true)}
                      >
                        <div className="radio-indicator">
                          <div
                            className={`radio-circle ${
                              isIndianCitizen ? "checked" : ""
                            }`}
                          >
                            {isIndianCitizen && (
                              <div className="radio-dot"></div>
                            )}
                          </div>
                        </div>
                        <span className="citizenship-label">Yes</span>
                      </div>
                      <div
                        className={`citizenship-box ${
                          !isIndianCitizen ? "selected" : ""
                        }`}
                        onClick={() => setIsIndianCitizen(false)}
                      >
                        <div className="radio-indicator">
                          <div
                            className={`radio-circle ${
                              !isIndianCitizen ? "checked" : ""
                            }`}
                          >
                            {!isIndianCitizen && (
                              <div className="radio-dot"></div>
                            )}
                          </div>
                        </div>
                        <span className="citizenship-label">No</span>
                      </div>
                    </div>
                  </div>

                  {!isIndianCitizen && (
                    <div className="form-penta position-relative mt-3">
                      <div
                        className="country-select-wrapper"
                        ref={countryDropdownRef}
                      >
                        <div
                          className="country-select-trigger"
                          onClick={() => {
                            setShowCountryDropdown(!showCountryDropdown);
                            if (!showCountryDropdown) {
                              setCountrySearchQuery("");
                            }
                          }}
                        >
                          {countryName ? (
                            <div className="country-selected">
                              <img
                                src={getFlagUrl(countryName)}
                                alt={countryName}
                                className="country-flag"
                                onError={(e) => {
                                  e.target.style.display = "none";
                                }}
                              />
                              <span>{countryName}</span>
                            </div>
                          ) : (
                            <span className="country-placeholder">
                              Select your country
                            </span>
                          )}
                          <span
                            className={`country-arrow ${
                              showCountryDropdown ? "open" : ""
                            }`}
                          >
                            ▼
                          </span>
                        </div>
                        {showCountryDropdown && (
                          <div className="country-dropdown">
                            <div className="country-search-wrapper">
                              <input
                                type="text"
                                className="country-search-input"
                                placeholder="Search country..."
                                value={countrySearchQuery}
                                onChange={(e) =>
                                  setCountrySearchQuery(e.target.value)
                                }
                                onClick={(e) => e.stopPropagation()}
                                autoFocus
                              />
                            </div>
                            <div className="country-dropdown-list">
                              {countries
                                .filter((country) =>
                                  country
                                    .toLowerCase()
                                    .includes(countrySearchQuery.toLowerCase())
                                )
                                .map((country) => (
                                  <div
                                    key={country}
                                    className={`country-option ${
                                      countryName === country ? "selected" : ""
                                    }`}
                                    onClick={() => {
                                      setCountryName(country);
                                      setShowCountryDropdown(false);
                                      setCountrySearchQuery("");
                                    }}
                                  >
                                    <img
                                      src={getFlagUrl(country)}
                                      alt={country}
                                      className="country-flag"
                                      onError={(e) => {
                                        e.target.style.display = "none";
                                      }}
                                    />
                                    <span>{country}</span>
                                  </div>
                                ))}
                              {countries.filter((country) =>
                                country
                                  .toLowerCase()
                                  .includes(countrySearchQuery.toLowerCase())
                              ).length === 0 && (
                                <div className="country-no-results">
                                  No countries found
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  <p className="my-4 mb-3 small text-white-50">
                    By continuing, you agree to our <Link>Terms of Use</Link>{" "}
                    and <Link>Privacy Policy</Link>{" "}
                  </p>
                  <button
                    type="button"
                    className="btnPrimary"
                    onClick={handleProceed}
                    disabled={!isIndianCitizen && countryName.trim() === ""}
                  >
                    Proceed
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          // This is where the existing login/OTP flow will go, conditionally rendered
          // based on isIndianCitizen.
          // For now, I'll keep the existing !disabled block here.
          <>
            {isIndianCitizen ? (
              // Existing mobile number OTP flow
              !disabled ? (
                <div className="login-penta bg-common mb-5">
                  <div className="row align-items-center">
                    <div className="">
                      <div className="login-content text-center">
                        {!hideEntryBackButton && (
                          <button
                            type="button"
                            className="btnLink btn-back mb-3"
                            onClick={handleGoBack}
                            style={{
                              textDecoration: "none",
                              cursor: "pointer",
                            }}
                          >
                            ← Back
                          </button>
                        )}
                        <h1 className="my-2 fs-2">Welcome to IceSpice</h1>
                        <p className="text-white-30 ">
                          Please enter 10 digit mobile number, login and unlock
                          awesome discount
                        </p>
                        <div className="form-penta position-relative mt-5">
                          <span className="position-absolute">+91</span>
                          <input
                            type="tel"
                            inputMode="numeric"
                            className="form_control"
                            name="mobileNumber"
                            id="mobileNumber"
                            placeholder="Enter mobile number"
                            value={mobile}
                            onChange={(e) => {
                              // Remove all non-numeric characters
                              const numericValue = e.target.value.replace(
                                /\D/g,
                                ""
                              );
                              // Limit to 10 digits
                              if (numericValue.length <= 10) {
                                setMobile(numericValue);
                              }
                            }}
                            onKeyPress={(e) => {
                              // Prevent non-numeric characters from being entered
                              if (
                                !/[0-9]/.test(e.key) &&
                                e.key !== "Backspace" &&
                                e.key !== "Delete" &&
                                e.key !== "Tab"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            autoComplete="off"
                            maxLength={10}
                            autoFocus={true}
                          />
                        </div>
                        {mobile?.length < 10 && mobile?.length !== 0 ? (
                          <span style={{ fontSize: "12px", color: "red" }}>
                            Please Enter 10 digits mobile number
                          </span>
                        ) : (
                          ""
                        )}

                        <div className="signNwTxtInfo">
                          <div className="signUpTxt" style={{ color: "red" }}>
                            {alertInfos.msg}
                          </div>
                        </div>

                        <p className="my-4 mb-100 small text-white-50">
                          By continuing, you agree to our{" "}
                          <Link>Terms of Use</Link> and{" "}
                          <Link>Privacy Policy</Link>{" "}
                        </p>
                        <button
                          type="button"
                          name="Send_OTP"
                          className="btnPrimary"
                          disabled={mobile.length === 10 ? false : true}
                          onClick={(e) => submitHandle(e)}
                        >
                          Continue
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="login-penta bg-common">
                  <div className="headSec">
                    <button
                      type="button"
                      className="btnLink btn-back mb-3"
                      onClick={handleGoBack}
                      style={{
                        textDecoration: "none",
                        cursor: "pointer",
                        display: "block",
                        margin: "0 auto",
                      }}
                    >
                      ← Back
                    </button>
                    {/* <h2 style={{marginBottom:"10px"}}>Welcome</h2> */}
                    {/* <p>OTP sent to registered number on +91 {mobile}</p> */}
                    {/* <p className="text-white-30 ">awesome discount</p> */}
                  </div>
                  <div className="otpFormSec">
                    <div className="signNwTxtInfo d-flex flex-column align-items-center">
                      {otpSentMessage && (
                        <div
                          className="mb-2"
                          style={{ fontSize: "17px", color: "#51cf66" }}
                        >
                          {otpSentMessage}
                        </div>
                      )}{" "}
                      {otpErrorMessage && (
                        <div
                          className={`otp-alert-message otp-alert-danger`}
                          style={{ marginTop: otpSentMessage ? "8px" : "0" }}
                        >
                          <div className="otp-alert-content">
                            <span className="otp-alert-icon">⚠️</span>
                            <span className="otp-alert-text">
                              {otpErrorMessage}
                            </span>
                          </div>
                        </div>
                      )}
                      {/* {alertInfo.cls === "success" &&
                        !otpErrorMessage &&
                        alertInfo.msg && (
                          <div style={{ fontSize: "17px" }}>
                            {alertInfo.msg}
                          </div>
                        )}{" "} */}
                    </div>

                    <div className=" d-flex justify-content-center">
                      <div className="mb-2">{showTimer}</div>
                    </div>
                      <div className=" d-flex justify-content-center mb-0">
                        {" "}
                        <div
                          className="mb-2"
                          style={{ fontSize: "16px", color: "#8e8e8e" }}
                        >
                          {isAutoReading
                            ? "📱 Auto-reading OTP from SMS..."
                            : otpAutoReadSupported
                            ? "📱 Auto-read available (Chrome/Edge on Android)"
                            : "Please enter OTP manually"}
                        </div>
                      </div>
                    <OTPInput
                      value={OTP}
                      onChange={setOTP}
                      autoFocus
                      OTPLength={6}
                      autocomplete="one-time-code"
                      otpType="number"
                      disabled={false}
                      className="otpinputs justify-content-center"
                    />
                    <div className="d-flex justify-content-between ">
                      <div className="">
                        <button
                          type="button"
                          className="btnLink"
                          onClick={() => {
                            // Clear any running timers
                            if (otpTimerRef.current) {
                              clearInterval(otpTimerRef.current);
                              otpTimerRef.current = null;
                            }
                            if (otpTimeoutRef.current) {
                              clearTimeout(otpTimeoutRef.current);
                              otpTimeoutRef.current = null;
                            }
                            setAlertInfos({
                              ...alertInfo,
                              visible: false,
                              cls: "success",
                              msg: ``,
                            });
                            setDisabled(false);
                            setRegisteredMobile("");
                            setShowTimer("");
                            setTime(false);
                            setOtpSentMessage("");
                            setOtpErrorMessage("");
                          }}
                        >
                          Edit Number
                        </button>
                      </div>
                      <div className="">
                        <button
                          disabled={time}
                          type="button"
                          name="Send_OTP"
                          className="btnLink"
                          onClick={(e) => submitHandle(e)}
                        >
                          Resend OTP
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="actSec mt-30 mb-100">
                    <button
                      type="button"
                      className="btnPrimary"
                      id="validOtp"
                      disabled={OTP.length === 6 ? false : true}
                      onClick={(e) => {
                        verifyOtp(e);
                        setIsOtp(true);
                      }}
                      style={{ width: "80%" }}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              )
            ) : // Email verification flow (for non-Indian citizens)
            !disabled ? (
              <div className="login-penta bg-common mb-5">
                <div className="row align-items-center">
                  <div className="">
                    <div className="login-content text-center">
                      {!hideEntryBackButton && (
                        <button
                          type="button"
                          className="btnLink btn-back mb-3"
                          onClick={() => setShowVerificationForm(false)}
                          style={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          ← Back
                        </button>
                      )}
                      <h1 className="my-2 fs-2">Welcome to IceSpice</h1>
                      <p className="text-white-30 ">
                        Please enter your email address to login and unlock
                        awesome discount
                      </p>
                      <div className="form-penta position-relative mt-5">
                        <input
                          type="email"
                          className="form_control"
                          name="email"
                          id="email"
                          placeholder="Enter your email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          autoComplete="off"
                          autoFocus={true}
                        />
                      </div>
                      {email.trim() === "" ? (
                        <span style={{ fontSize: "12px", color: "red" }}>
                          Please Enter your email address
                        </span>
                      ) : (
                        ""
                      )}

                      {alertInfos.msg && (
                        <div className={`otp-alert-message otp-alert-danger`}>
                          <div className="otp-alert-content">
                            <span className="otp-alert-icon">⚠️</span>
                            <span className="otp-alert-text">
                              {alertInfos.msg}
                            </span>
                          </div>
                        </div>
                      )}

                      <p className="my-4 mb-100 small text-white-50">
                        By continuing, you agree to our{" "}
                        <Link>Terms of Use</Link> and{" "}
                        <Link>Privacy Policy</Link>{" "}
                      </p>
                      <button
                        type="button"
                        name="Send_Email_OTP"
                        className="btnPrimary"
                        disabled={email.trim() === ""}
                        onClick={(e) => submitHandle(e)}
                      >
                        Send OTP
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="login-penta bg-common">
                <div className="headSec">
                  <button
                    type="button"
                    className="btnLink btn-back mb-3"
                    onClick={() => setShowVerificationForm(false)}
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                      display: "block",
                      margin: "0 auto",
                    }}
                  >
                    ← Back
                  </button>
                  {/* <h2 style={{marginBottom:"10px"}}>Welcome</h2> */}
                  {/* <p>OTP sent to registered email on {email}</p> */}
                  {/* <p className="text-white-30 ">awesome discount</p> */}
                </div>
                <div className="otpFormSec">
                  <div className="signNwTxtInfo d-flex flex-column align-items-center">
                    {otpSentMessage && (
                      <div
                        className="mb-2"
                        style={{ fontSize: "17px", color: "#51cf66" }}
                      >
                        {otpSentMessage} jgkrttyy
                      </div>
                    )}
                    {otpErrorMessage && (
                      <div
                        className={`otp-alert-message otp-alert-danger`}
                        style={{ marginTop: otpSentMessage ? "8px" : "0" }}
                      >
                        <div className="otp-alert-content">
                          <span className="otp-alert-icon">⚠️</span>
                          <span className="otp-alert-text">
                            {otpErrorMessage}
                          </span>
                        </div>
                      </div>
                    )}
                    {alertInfo.cls === "success" &&
                      !otpErrorMessage &&
                      alertInfo.msg && (
                        <div className={`otp-alert-message otp-alert-success`}>
                          <div className="otp-alert-content">
                            <span className="otp-alert-icon">✓</span>
                            <span className="otp-alert-text">
                              {alertInfo.msg}
                            </span>
                          </div>
                        </div>
                      )}
                  </div>

                  <div className=" d-flex justify-content-center">
                    <div className="mb-2">{showTimer}</div>
                  </div>
                  <div className=" d-flex justify-content-center mb-4">
                    {" "}
                    <div
                      className="mb-2"
                      style={{ fontSize: "14px", color: "#666" }}
                    >
                      Please enter OTP manually
                    </div>
                  </div>
                  <OTPInput
                    value={emailOTP}
                    onChange={setEmailOTP}
                    autoFocus
                    OTPLength={6}
                    otpType="number"
                    disabled={false}
                    className="otpinputs justify-content-center"
                  />
                  <div className="d-flex justify-content-between ">
                    <div className="">
                      <button
                        type="button"
                        className="btnLink"
                        onClick={() => {
                          // Clear any running timers
                          if (otpTimerRef.current) {
                            clearInterval(otpTimerRef.current);
                            otpTimerRef.current = null;
                          }
                          if (otpTimeoutRef.current) {
                            clearTimeout(otpTimeoutRef.current);
                            otpTimeoutRef.current = null;
                          }
                          setAlertInfos({
                            ...alertInfo,
                            visible: false,
                            cls: "success",
                            msg: ``,
                          });
                          setDisabled(false);
                          setRegisteredEmail("");
                          setShowTimer("");
                          setTime(false);
                          setOtpSentMessage("");
                          setOtpErrorMessage("");
                        }}
                      >
                        Edit Email
                      </button>
                    </div>
                    <div className="">
                      <button
                        disabled={time}
                        type="button"
                        name="Send_Email_OTP"
                        className="btnLink"
                        onClick={(e) => submitHandle(e)}
                      >
                        Resend OTP
                      </button>
                    </div>
                  </div>
                </div>
                <div className="actSec mt-30 mb-100">
                  <button
                    type="button"
                    className="btnPrimary"
                    id="validOtp"
                    disabled={emailOTP.length === 6 ? false : true}
                    onClick={(e) => {
                      verifyOtp(e); // Need to adapt verifyOtp for email
                      setIsOtp(true);
                    }}
                    style={{ width: "80%" }}
                  >
                    Continue
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
      {rewardModal.visible && (
        <div className="reward-modal-overlay">
          <div className="reward-modal-card">
            <div className="reward-modal-icon">🎉</div>
            <h3>Congratulations!</h3>
            <p className="mb-3">{rewardModal.message}</p>
            <button className="btnPrimary" onClick={handleRewardModalClose}>
              Continue
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default BottomLogin;
